var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row.status == 2)?_c('div',{staticClass:"btn-group"},[_c('img',{staticClass:"leftImg1 mr-3",attrs:{"src":require("@/assets/images/icons/cerrado.svg")}})]):_c('div',{staticClass:"btn-group"},[_c('img',{staticClass:"leftImg1 mr-3",attrs:{"src":require("@/assets/images/icons/pendiente.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }